import React, { useCallback, useState } from 'react';
import { AnyObject } from 'final-form';

import Colors from 'Wpds/colors/ColorConstants';
import { Select } from 'Shared/components/FormComponents/FormSelect';
import { createFormField } from 'Shared/utils/createFormField';

import { useTranslation } from 'Shared/contexts/TranslationsContext';
import RecurringMeetingOption from './RecurringMeetingOption/RecurringMeetingOption';

import './FormSelect.scss';

const selectStyles = {
  option: base => ({ ...base, minHeight: '32px', height: '32px', padding: '4px 12px' }),
  control: base => ({ ...base, minHeight: '32px', height: '32px' }),
  menu: base => ({ ...base, border: `1px solid ${Colors.blue[500]}` }),
  menuPortal: base => ({ ...base, zIndex: '1050' }),
};

function FormSelect({ value, onChange, groupRecurringMeetings, teammateRecurringMeetings, isGroup }: AnyObject) {
  const { tr } = useTranslation();
  const typedRecurringMeetings = isGroup ? groupRecurringMeetings : teammateRecurringMeetings;
  const recurringMeetings = value ? [...typedRecurringMeetings, value] : typedRecurringMeetings;
  const [searchValue, setSearchValue] = useState('');

  const filteredRecurringMeetings = searchValue
    ? recurringMeetings.filter(({ name }) => name.toLowerCase().includes(searchValue.toLowerCase()))
    : recurringMeetings;

  const handleSelectChange = useCallback(
    recurringMeetingId => onChange(recurringMeetings.find(({ id }) => id === recurringMeetingId)),
    [onChange, recurringMeetings]
  );

  const handleInputChange = useCallback(inputValue => setSearchValue(inputValue), []);

  return (
    <Select
      className="WorkspaceFormSelect mt-2"
      options={filteredRecurringMeetings}
      placeholder={tr('perform.sync_meetings_flow.form_select.select_calendar_meeting_placeholder')}
      value={value.id}
      menuPortalTarget={document.querySelector('body')}
      menuShouldBlockScroll
      inputValue={searchValue}
      onInputChange={handleInputChange}
      onChange={handleSelectChange}
      customStyles={selectStyles}
      components={{ Option: RecurringMeetingOption }}
      isClearable
    />
  );
}

export default createFormField(FormSelect);
